export function formatScore(score: number) {
  return (score * 1000).toFixed(0);
}

export function formatScoreAsNumber(score: number) {
  return +(score * 1000).toFixed(0);
}